import React from 'react';
import { AdminLayout } from '@/components/Layouts/AdminLayout';
import { Table, Button, Form, Input } from 'antd';
import { FormDrawer } from '@/components/Common/FormDrawer';
import { useFetchCompaniesApi } from '@/api/company';
import { useCompanyListHelper } from './helper';

export const CompanyList: React.FC = () => {
  const state = useCompanyListHelper();
  const fetchCompanies = useFetchCompaniesApi();
  React.useEffect(() => {
    fetchCompanies().then((res) => {
      state.dataSource.setList(res.map((r) => ({ ...r, key: r.id })));
    });
    // eslint-disable-next-line
  }, []);
  return (
    <AdminLayout>
      <h1>企業</h1>
      <p>
        <Button onClick={state.editDrawer.toCreate} type='primary'>
          新規追加
        </Button>
      </p>
      <Table columns={state.editDrawer.columns} dataSource={state.dataSource.list} />
      <FormDrawer title='Company' state={state.editDrawer.drawer}>
        <Form form={state.editDrawer.form} onFinish={state.onSubmit}>
          <Form.Item label='Name' name='name'>
            <Input placeholder='Name' />
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit'>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </FormDrawer>
    </AdminLayout>
  );
};
